export default __webpack_public_path__ + "static/media/ICx.ef9a32b7.png";